const passwordField = document.getElementById("form-password");
const togglePassword = document.querySelector(".form_input.password span");
const passwordShowIcon = document.getElementById("icon_show");
const passwordHiddenIcon = document.getElementById("icon_hidden");

togglePassword.addEventListener("click", function () {
  if (passwordField.type === "password") {
    passwordField.type = "text";
    passwordShowIcon.classList.remove("hidden");
    passwordHiddenIcon.classList.add("hidden");
  } else {
    passwordField.type = "password";
    passwordShowIcon.classList.add("hidden");
    passwordHiddenIcon.classList.remove("hidden");
  }
});